import { Animation, Instagram, Mail, YouTube } from "@mui/icons-material";
import {
  Box,
  Button,
  Collapse,
  Dialog,
  DialogContent,
  DialogTitle,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { useState } from "react";
import {
  Akshay,
  Appu,
  BadaBhai,
  Bhaskar,
  ChhotaBhai,
  DrDoctor,
  Gilli,
  InspectorRathore,
  MAD,
  Manjula,
  Parth,
  Riddhi,
  Satish,
  Trisha,
  VinodHasmukhani,
} from "../dataset/character_data";
import Character from "../models/character";

const ContactDetails = {
  mail: "nerurkarpratik@gmail.com",
  instagram: {
    id: "@playpratz",
    uri: "https://www.instagram.com/playpratz",
  },
  youtube: {
    id: "@playpratz",
    uri: "https://www.youtube.com/@PlayPratz",
  },
};

export const AboutPage: React.FC = () => {
  return (
    <>
      <Box paddingY={8} paddingX={2} margin="auto">
        <img
          alt="Parivaar Twist"
          src="/assets/misc/title.png"
          height={128}
          style={{ display: "block", margin: "auto" }}
        />
        <Box height={50} />
        <AboutTheShow />
        <Box height={24} />
        <CastList />
        <Box height={50} />
        <ContactDetailsPane />
        <Box height={25} />
        <RegistrationDetails />
      </Box>
    </>
  );
};

const AboutTheShow: React.FC = () => {
  return (
    <>
      {/* <Typography fontFamily={"monospace"} variant="h6">
        About <b>Parivaar Twist</b>:
      </Typography> */}
      <Box height={12} />
      <Typography variant="body1">
        <b>Parivaar Twist</b> is a Hindi-language animated sitcom about a
        seemingly ordinary family which finds itself in extraordinary
        situations.
        <br />
        <br />
        An urban family, The Sanzgiris — a righteous mother; a naïve
        househusband; a reserved, intelligent teenage daughter; a streetwise
        tweenage son — struggle through each other's antics and their whacky
        townspeople.
        <br />
        <br />
        The Sanzgiris are a madcap family whose contrasting personalities cause
        them to end up in a wide variety of situations — either individually or
        together. How they deal with these perplexing scenarios forms the crux
        of every episode. Maybe Trisha, the mother, becomes a wanted hacker.
        Maybe Akshay, the father, discovers a well-known societal construct.
        Maybe Riddhi, the daughter, becomes a vigilante to fight crime. Maybe
        Parth, the son, is travelling in time with a mad scientist. Maybe it's
        all happening together!?
        <br />
        <br />
        The world of Parivaar Twist is made of eccentric characters and
        scenarios that satirize the world we live in.
      </Typography>
      <Box height={24} />
      <ListItem>
        <ListItemIcon>
          <Animation />
        </ListItemIcon>
        <ListItemText
          primary="Family Guy, Futurama, The Simpsons"
          secondary="Animation References"
        />
      </ListItem>
    </>
  );
};

const CastList: React.FC = () => {
  const [selectedActor, setSelectedActor] = useState<String>("");

  return (
    <>
      <Typography variant="body1">
        This pitch deck features the voices of:
      </Typography>
      <Typography fontFamily="monospace" variant="caption" fontStyle="italic">
        (click on a cast member to see characters played by them)
      </Typography>
      <Box height={16} />
      {getSingleCastMember("Pratik Nerurkar", [
        Akshay,
        Parth,
        MAD,
        Bhaskar,
        ChhotaBhai,
        Gilli,
        BadaBhai,
        VinodHasmukhani,
        DrDoctor,
      ])}
      <Box height={16} />
      {getSingleCastMember("Madhumita Chatterjee", [Trisha, Manjula])}
      <Box height={16} />
      {getSingleCastMember("Rutuja Shelar", [Riddhi])}
      <Box height={16} />
      {getSingleCastMember("JohnAnand Abraham", [Appu, Satish])}
      <Box height={16} />
      {getSingleCastMember("Saspat Acharya", [InspectorRathore])}
    </>
  );

  function getSingleCastMember(
    actor: String,
    characters: Character[],
  ): React.ReactNode {
    const charactersVoicedByActor = characters.map((character, index) => {
      if (index === 0) return character.name;
      return ", " + character.name;
    });
    return (
      <>
        <Button
          variant="text"
          color="info"
          onClick={() =>
            actor === selectedActor
              ? setSelectedActor("")
              : setSelectedActor(actor)
          }
          style={{ fontSize: 12, fontWeight: "bold" }}
        >
          {actor}
        </Button>
        <Box paddingLeft={2}>
          <Collapse in={actor === selectedActor}>
            <Typography fontFamily={"monospace"} variant={"body2"}>
              {charactersVoicedByActor}
            </Typography>
          </Collapse>
        </Box>
      </>
    );
  }
};

const ContactDetailsPane: React.FC = () => {
  const [showContactDetails, setShowContactDetails] = useState(false);

  return (
    <>
      <Typography variant="body1" fontFamily={"monospace"} textAlign="center">
        Concept, Characters, Episodes and Website created by{" "}
        <Link
          onClick={() => setShowContactDetails(true)}
          style={{ cursor: "pointer", fontWeight: "bold" }}
        >
          Pratik Nerurkar
        </Link>
      </Typography>
      <Dialog
        open={showContactDetails}
        onClose={() => setShowContactDetails(false)}
      >
        <DialogTitle>Contact Me</DialogTitle>
        <DialogContent>
          <List>
            <ListItem>
              <ListItemIcon>
                <Mail />
              </ListItemIcon>
              <Link href={"mailto:" + ContactDetails.mail}>
                <ListItemText primary={ContactDetails.mail} />
              </Link>
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <Instagram />
              </ListItemIcon>
              <Link href={ContactDetails.instagram.uri} target="_blank">
                <ListItemText primary={ContactDetails.instagram.id} />
              </Link>
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <YouTube />
              </ListItemIcon>
              <Link href={ContactDetails.youtube.uri} target="_blank">
                <ListItemText primary={ContactDetails.youtube.id} />
              </Link>
            </ListItem>
          </List>
        </DialogContent>
      </Dialog>
    </>
  );
};

const RegistrationDetails: React.FC = () => (
  <Typography
    fontFamily="monospace"
    variant="body2"
    textAlign="center"
    fontStyle="italic"
  >
    All content has been registered with{" "}
    <b>Screenwriters Association of India (SWA)</b>
  </Typography>
);
